import React, { useState } from "react";
import Slider from "@mui/material/Slider";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to bottom right, #f3e8ff, #e0e7ff);
`;

const Card = styled.div`
  width: 100%;
  max-width: 28rem;
  padding: 2rem;
  background: white;
  border-radius: 1rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
`;

const SliderContainer = styled.div`
  position: relative;
  width: 100%;
  padding: 0 1rem;
`;

const SliderLabel = styled.label`
  font-size: 0.875rem;
  font-weight: 500;
  color: #4b5563;
  display: block;
  margin-bottom: 1rem;
`;

const TickMarksContainer = styled.div`
  position: relative;
  height: 1.5rem;
  margin-top: 0.5rem;
`;

const TickMark = styled.div`
  position: absolute;
  transform: translateX(-50%);
  font-size: 0.75rem;
  color: #6b7280;
`;

const SelectedValue = styled.span`
  font-size: 3.75rem;
  font-weight: bold;
  background: linear-gradient(to right, #8b5cf6, #6366f1);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: block;
  text-align: center;
  margin-top: 2rem;
`;

function StylishSlider({ selection, value, onChange }) {
  const minValue = 1;
  const maxValue = 10;

  const handleSliderChange = (event, newValue) => {
    onChange(newValue);
  };

  return (
    <SliderContainer>
      {/* <SliderLabel>Use the slider:</SliderLabel> */}
      <Slider
        value={value}
        onChange={handleSliderChange}
        min={minValue}
        max={maxValue}
        step={1}
        sx={{
          "& .MuiSlider-thumb": {
            border:
              selection === "Forward"
                ? "2.5px solid #1976D2"
                : selection === "Backward"
                ? "2.5px solid #FF8787"
                : "2.5px solid #7dfa87",
            background: "#fff",
          },
          "& .MuiSlider-track": {
            backgroundColor:
              selection === "Forward"
                ? "#1976D2"
                : selection === "Backward"
                ? "#FF8787"
                : "#12cc12",
            border: "none",
          },
          "& .MuiSlider-rail": {
            backgroundColor: "#d2d2d4",
          },
        }}
      />
      <TickMarksContainer>
        {Array.from(
          { length: maxValue - minValue + 1 },
          (_, i) => i + minValue
        ).map((num) => (
          <TickMark
            key={num}
            style={{
              left: `${((num - minValue) / (maxValue - minValue)) * 100}%`,
              fontWeight: num === value ? 700 : 400,
              color: num === value && "black",
              scale: num === value ? "1.16" : "1",
            }}
          >
            {num}
          </TickMark>
        ))}
      </TickMarksContainer>
    </SliderContainer>
  );
}

export default StylishSlider;
